<div class="main">
  <!-- Add loading spinner component -->
  <app-loading *ngIf="isLoading"></app-loading>

  <!-- <f-alert variant="warning" in-container>
        <p>We are working through a subscription feature outage. As we work to resolve, you or your account manager can export the report information you need by selecting the report on the Reports & Dashboards page and selecting export to CSV or Excel.</p>
    </f-alert> -->

  <div class="breadcrumbs">
    <f-breadcrumb
      divider=">"
      [breadcrumbItems]="items"
      (breadcrumbSelected)="onBreadcrumbSelected($event)"
    >
    </f-breadcrumb>
  </div>

  <h1 *ngIf="isPageModeEdit == true; else subcribeTemplate">
    Edit {{ selectedSubscription.title }}
  </h1>
  <ng-template #subcribeTemplate>
    <h1>Subscribe to {{ subscribeItem?.title }}</h1>
  </ng-template>

  <div *ngIf="!isFormReady()">
    <p>Loading form...</p>
  </div>
  <form
    *ngIf="isFormReady()"
    [formGroup]="scheduleForm"
    (ngSubmit)="onSubmit()"
  >
    <div class="form-control">
      <div>Subscription Name <span class="required">*</span></div>
      <input
        type="text"
        id="subscriptionName"
        formControlName="subscriptionName"
        placeholder="Enter a name for this subscription"
      />
      <div *ngIf="validationErrors['subscriptionName']" class="error-message">
        {{ validationErrors["subscriptionName"] }}
      </div>
      <p class="field-hint">
        Required. Enter a descriptive name to identify this subscription.
      </p>

      <div>
        <app-parameter-table
          (onParameterChange)="updateParameters($event)"
          [dashboardId]="dashboardId"
          [initialParameterValues]="getInitialParameterValues()"
          [delayInitialization]="true"
          [requiredParameters]="requiredDateParameters"
          [invalidParameters]="invalidDateParameters"
        ></app-parameter-table>
      </div>
      <h2>Format</h2>
      <select
        *ngIf="formatOptions.length === 1"
        formControlName="format"
        id="format"
      >
        <option [ngValue]="formatOptions[0]">{{ formatOptions[0] }}</option>
      </select>
      <select
        *ngIf="formatOptions.length > 1"
        formControlName="format"
        id="format"
      >
        <option value="" disabled selected>Select an option</option>
        <option *ngFor="let option of formatOptions" [value]="option">
          {{ option }}
        </option>
      </select>
      <h2>Recurrence</h2>
      <div>Repeat</div>
      <select
        formControlName="frequency"
        id="frequency"
        (change)="onFrequencyChanged($event)"
      >
        <option value="" disabled selected>Select an option</option>
        <option *ngFor="let option of frequencyOptions" [value]="option.value">
          {{ option.name }}
        </option>
      </select>
    </div>

    <!-- Dates Section - Moved outside conditional display -->
    <div class="form-control">
      <h2>Dates</h2>
      <div>Subscription Start Date <span class="required">*</span></div>
      <input
        type="text"
        id="startDate"
        formControlName="startDate"
        placeholder="MM/DD/YYYY"
        (blur)="validateDateFormat('startDate')"
        (focus)="ensureStartDateHasValue()"
        (input)="formatDateInput('startDate', $event)"
      />
      <div *ngIf="validationErrors['startDate']" class="error-message">
        {{ validationErrors["startDate"] }}
      </div>
      <p class="field-hint">Required. Format: MM/DD/YYYY</p>

      <div style="margin-top: 20px">Subscription End Date</div>
      <input
        type="text"
        id="endDate"
        formControlName="endDate"
        placeholder="MM/DD/YYYY"
        (blur)="validateDateFormat('endDate')"
        (input)="formatDateInput('endDate', $event)"
      />
      <div *ngIf="validationErrors['endDate']" class="error-message">
        {{ validationErrors["endDate"] }}
      </div>
      <p class="field-hint">
        Optional. Must be after start date. Format: MM/DD/YYYY
      </p>
    </div>

    <!-- Additional form sections - only show when form is fully ready -->
    <ng-container
      *ngIf="
        isFormReady() &&
        scheduleForm.get('frequency')?.value &&
        scheduleForm.get('format')?.value
      "
    >
      <ng-container *ngIf="scheduleForm.get('frequency')?.value === 'daily'">
        <div class="form-control">
          <h2>Daily Schedule</h2>

          <div *ngFor="let option of dailyOptions; let i = index">
            <input
              type="radio"
              [value]="option.initialValue"
              formControlName="dailyOption"
              [id]="option.initialValue"
              (change)="onDailyOptionChanged($event)"
              class="custom-radio"
            />
            <label [for]="option.initialValue"> {{ option.labelText }}</label>

            <ng-container
              *ngIf="
                scheduleForm.get('dailyOption')?.value === 'onDays' &&
                option.initialValue === 'onDays'
              "
            >
              <div class="schedule-block">
                <h3>Select Days</h3>
                <div *ngFor="let day of daysOfWeek">
                  <input
                    type="checkbox"
                    [formControlName]="day.initialValue"
                    [id]="day.initialValue"
                    class="custom-checkbox"
                    (change)="onDaySelectionChanged()"
                  />
                  <label [for]="day.initialValue"> {{ day.labelText }}</label>
                </div>
                <div *ngIf="validationErrors['dailySchedule']" class="error-message">
                  {{ validationErrors['dailySchedule'] }}
                </div>
              </div>
            </ng-container>

            <ng-container
              *ngIf="
                scheduleForm.get('dailyOption')?.value === 'repeatAfter' &&
                option.initialValue === 'repeatAfter'
              "
            >
              <select
                formControlName="repeatDays"
                id="repeatDays"
                class="custom-select-small"
              >
                <option
                  *ngFor="let repeatAfterOption of repeatAfterOptions"
                  [value]="repeatAfterOption.value"
                >
                  {{ repeatAfterOption.name }}
                </option>
              </select>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <!--frequency = daily -->

      <ng-container *ngIf="scheduleForm.get('frequency')?.value === 'weekly'">
        <div class="form-control">
          <div>Repeat every</div>
          <select formControlName="weeklyRepeat" id="weeklyRepeat">
            <option
              *ngFor="let weeklyRepeatOption of weeklyRepeatOptions"
              [value]="weeklyRepeatOption.value"
            >
              {{ weeklyRepeatOption.name }}
            </option>
          </select>

          <div class="schedule-block">
            <h3>Select Days</h3>
            <div *ngFor="let day of daysOfWeek">
              <input
                type="checkbox"
                [formControlName]="day.initialValue"
                [id]="day.initialValue + 'Weekly'"
                class="custom-checkbox"
              />
              <label [for]="day.initialValue + 'Weekly'">
                {{ day.labelText }}</label
              >
            </div>
          </div>
        </div>
      </ng-container>
      <!--frequency = weekly -->

      <ng-container
        *ngIf="scheduleForm.get('frequency')?.value === 'monthly'"
        class="monthly-schedule-container"
      >
        <!-- Add monthly options here -->
        <h2>Monthly Schedule</h2>
        <p class="months-subhead">Months:</p>

        <div class="schedule-block">
          <div class="months-grid-container">
            <div *ngFor="let month of monthsOfYearSelect">
              <input
                type="checkbox"
                [formControlName]="month.name"
                [id]="month.value"
                class="month-grid-item, custom-checkbox"
              />
              <label for="month.value"> {{ month.name }} </label>
            </div>
          </div>
        </div>
        <div
          *ngFor="let mOption of monthlyOptions; let i = index"
          class="radio-selection"
        >
          <input
            type="radio"
            [value]="mOption.value"
            formControlName="monthlyOption"
            [id]="mOption.value"
            (change)="onMonthlyOptionChanged($event)"
            class="custom-radio"
          />
          <label [for]="mOption.value"> {{ mOption.name }}</label>

          <ng-container
            *ngIf="
              scheduleForm.get('monthlyOption')?.value === 'onWeekOfMonth' &&
              mOption.value === 'onWeekOfMonth'
            "
          >
            <select
              formControlName="weekOfMonth"
              id="weekOfMonth"
              class="custom-select-small"
            >
              <option
                *ngFor="let weekOfMonthOption of weekOfMonth"
                [value]="weekOfMonthOption.value"
              >
                {{ weekOfMonthOption.name }}
              </option>
            </select>
          </ng-container>

          <ng-container
            *ngIf="
              scheduleForm.get('monthlyOption')?.value === 'onCalendarDays' &&
              mOption.value === 'onCalendarDays'
            "
          >
            <input
              type="text"
              id="calendarDays"
              formControlName="calendarDays"
              placeholder="1,3-5"
              class="textbox-padding"
            />
          </ng-container>
        </div>
      </ng-container>
      <!--frequency = monthly -->
      <!--frequency = monthly -->

      <ng-container *ngIf="scheduleForm.get('frequency')?.value === 'yearly'">
        <!-- Add yearly options here -->
        <div class="form-control">
          <h2>Yearly Schedule</h2>
          <div class="form-control">
            <div>Select a month</div>
            <select formControlName="monthSelected" id="monthSelected">
              <option
                *ngFor="let monthsOfYear of monthsWithDays"
                [value]="monthsOfYear.value"
              >
                {{ monthsOfYear.name }}
              </option>
            </select>
          </div>
          <div class="form-control">
            <div>Select a day</div>
            <select
              formControlName="daysOfTheMonthSelected"
              id="daysOfTheMonthSelected"
            >
              <option *ngFor="let day of numberOfDays" [value]="day">
                {{ day }}
              </option>
            </select>
          </div>
        </div>
      </ng-container>
      <!--frequency = yearly -->

      <div class="form-control">
        <h2>Time</h2>
        <div>Time (US Central)</div>
        <div class="time-selector">
          <!-- Hour selection -->
          <div class="time-input-group">
            <label for="time">Hour</label>
            <select formControlName="time" id="time" (change)="onHourChanged()">
              <option *ngFor="let option of timeOptions" [value]="option.value">
                {{ option.name }}
              </option>
            </select>
          </div>

          <!-- Minute selection -->
          <div class="time-input-group">
            <label for="minute">Minute</label>
            <select formControlName="minute" id="minute">
              <option
                *ngFor="let option of minuteOptions"
                [value]="option.value"
              >
                {{ option.name }}
              </option>
            </select>
          </div>

          <!-- AM/PM selection -->
          <div class="time-input-group">
            <label for="ampm">AM/PM</label>
            <select formControlName="ampm" id="ampm" (change)="onAmPmChanged()">
              <option *ngFor="let option of ampmOptions" [value]="option.value">
                {{ option.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- Recurrence Summary -->
      <div
        class="form-control recurrence-summary"
        *ngIf="getRecurrenceSummary() && scheduleForm.get('time')?.value"
      >
        <p class="summary-text">
          <b>{{ getRecurrenceSummary() }}</b>
        </p>
        <p class="cancellation-notice">
          <b
            >Your subscription will be cancelled if there is no activity within
            the past 60 days</b
          >
        </p>
      </div>

      <!-- Notification Settings Alert -->
      <div *ngIf="showNotificationAlert" style="margin: 20px 0;">
        <f-alert
          variant="warning"
          in-container
          class="column-12"
        >
          <p>
            To receive subscription notifications via email, please turn on the
            <a
              href="javascript:void(0)"
              (click)="openSettingsPage()"
              style="color: inherit; text-decoration: underline"
              >global notifications setting</a
            >.
          </p>
        </f-alert>
      </div>

      <div class="form-control">
        <label>Notifications </label>
        <!-- switch buttons-->
        <label
          class="padded-off-label"
          [class.disabled]="!globalNotificationsEnabled"
          >Off</label
        >
        <label class="switch" [class.disabled]="!globalNotificationsEnabled">
          <input
            type="checkbox"
            id="notification"
            formControlName="notification"
          />
          <span class="slider"></span>
        </label>
        <label
          class="padded-on-label"
          [class.disabled]="!globalNotificationsEnabled"
          >On</label
        >
      </div>

      <div *ngIf="showValidationAlert" style="margin-top: 10px; margin-bottom: 20px;">
        <f-alert variant="error" in-container>
          <p>Please fix the errors above.</p>
        </f-alert>
      </div>

      <div class="form-control">
        <div class="button-row">
          <f-button
            text="Apply"
            variant="progressive"
            (buttonClicked)="onSubmit()"
          >
          </f-button>
          <f-button
            type="button"
            text="Clear all"
            variant="action"
            (buttonClicked)="onClear()"
          >
          </f-button>
        </div>
      </div>
    </ng-container>
    <!-- frequency have value -->
  </form>
</div>
